import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  background-color: ${props => props.bgColor ? props.bgColor : '#fff'};
  background-image: url(${props => props.bgImg ? props.bgImg : ''});
  background-size: cover;
  background-position: center;
`
const SubContainer = styled.div`
  padding-top: 140px; 
  padding-bottom: 180px;
  border-top: ${props => props.topLine ? '1px solid #eee' : ''};
  position: relative;
  display: flex;
  flex-direction: ${props => props.flex ? props.flex : 'column'};
  justify-content: center;
  align-items: center;
  width: ${props => props.width ? props.width + 'px' : '1210px'};

@media (max-width: ${props => props.width ? props.width + 40 + 'px' : '1210px'}) {
    width: 100%;
    padding-left: 40px;
    padding-right: 40px;
    flex-direction: column;
  };
  @media (max-width: 780px) {
    padding-left: 20px;
    padding-right: 20px;
  };
`
const BasicContainer = ({ style, children, bgImg, flex, width, topLine = false, bgColor }) => {
  return (
    <Container bgImg={bgImg} bgColor={bgColor}>
      <SubContainer style={style} flex={flex} width={width} topLine={topLine}>
        {children}
      </SubContainer>
    </Container>
  )
}

export default BasicContainer;